import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'redux-form';
import UploadField from '../shared/UploadField';
import { checkButtonDisabled } from '../../utils/forms';

export default class UploadPrematchedPairsForm extends React.Component {
  static propTypes = {
    formId: PropTypes.string.isRequired,
    fieldName: PropTypes.string.isRequired,
    fieldLabel: PropTypes.string.isRequired,
    uploadFunction: PropTypes.func.isRequired,
    pristine: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.upload = this.upload.bind(this);
  }

  upload = params => {
    const { uploadFunction } = this.props;
    uploadFunction(params);
  };

  render() {
    const { formId, fieldName, fieldLabel, pristine, handleSubmit, submitting, reset } = this.props;

    return (
      <div className="row">
        <div className="col-md-12">
          <Form id={formId} onSubmit={handleSubmit(this.upload)}>
            <UploadField acceptedFileType=".csv" name={fieldName} label={fieldLabel} />
            <div>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={checkButtonDisabled(pristine, submitting)}
              >
                {submitting ? <i /> : <i />} Upload {fieldLabel}
              </button>&nbsp;
              <button type="reset" className="btn btn-cancel" onClick={reset}>
                Clear
              </button>
            </div>
          </Form>
        </div>
      </div>
    );
  }
}
